/**
 * Anonym förstapartsmätning — cookie-less, utan identifiering.
 * ------------------------------------------------------------
 * Skickar ENDAST path + utm_source/utm_campaign/utm_content vid verklig
 * sidladdning/navigation. INGA cookies, inget visitor/session-id, ingen IP,
 * ingen user-agent, ingen gclid/fbclid, ingen PII. Oberoende av cookie-consent
 * (ingen personuppgift lämnar webbläsaren). Backend aggregerar direkt i Mongo.
 *
 * Rör inte Meta Pixel, GA4, Google Ads, formulär, attribution eller cookie-bannern.
 */
import { API_URL } from "@/utils/api";
import { onConsentChange } from "@/utils/cookieConsent";

function utmFromUrl() {
  try {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get("utm_source") || undefined,
      utm_campaign: p.get("utm_campaign") || undefined,
      utm_content: p.get("utm_content") || undefined,
    };
  } catch {
    return {};
  }
}

/** Skicka en anonym sidvisning. Fire-and-forget, kraschar aldrig sidan. */
export function sendPageview(path) {
  if (typeof window === "undefined") return;
  try {
    const body = JSON.stringify({
      path: path || window.location.pathname || "/",
      ...utmFromUrl(),
    });
    fetch(`${API_URL}/api/analytics/pageview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}

/**
 * När cookie-komponenten sparar ett aktivt beslut ökas anonyma aggregerade
 * räknare (marketing_granted / marketing_denied). Lyssnar på befintlig
 * consent-händelse utan att ändra consent-logiken eller bannerns UI.
 */
export function initConsentCounter() {
  if (typeof window === "undefined") return;
  onConsentChange((e) => {
    try {
      const marketing = !!(e && e.detail && e.detail.marketing);
      fetch(`${API_URL}/api/analytics/consent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ marketing }),
        keepalive: true,
      }).catch(() => {});
    } catch {
      /* ignore */
    }
  });
}
